// ===== 可調整參數區塊 =====

// 1. 行銷活動 Popup 設定（登入與否都顯示）
const marketingConfig = {
  id: "20261104_v1",
  startTime: "2026-11-04T10:00:00+08:00",
  endTime:   "2026-11-11T10:00:00+08:00",
  storageKey: "polylulu_marketing_shown3",
  content: {
    th: {
      img: "https://cdn.shopify.com/s/files/1/0727/6075/4365/files/TH_1dcae2e4-d098-4236-a556-006e0ed38621.png?v=1793725432",
      link: "https://polylulu.shop/yJbMX"
    },
    en: {
      img: "https://cdn.shopify.com/s/files/1/0727/6075/4365/files/TH_1dcae2e4-d098-4236-a556-006e0ed38621.png?v=1793725432",
      link: "https://polylulu.shop/yJbMX"
    }
  }
};

// 2. 迎新 Popup 設定（僅未登入顯示）
const welcomeConfig = {
  id: "welcome_v9",
  storageKey: "polylulu_welcome_shown",
  content: {
    th: {
      img: "https://cdn.shopify.com/s/files/1/0727/6075/4365/files/20260812_TH__RM100_RM10.png?v=1786593810",
      link: "https://polylulu.shop/iqfpf"
    },
    en: {
      img: "https://cdn.shopify.com/s/files/1/0727/6075/4365/files/20260812_TH__RM100_RM10.png?v=1786593810",
      link: "https://polylulu.shop/iqfpf"
    }
  }
};

// ===== 以下不要修改，除非有特殊需求 =====

document.addEventListener("DOMContentLoaded", function () {
  try {
    const path = location.pathname || "";

    // ─── 排除特定頁面 ────────────────────────────────────────────────
    if (
      path.includes("checkout") ||
      path.includes("checkouts") ||
      path.includes("cart") ||
      path.includes("/login") ||
      path.includes("/account/login") ||
      path.includes("/register") ||
      path.includes("/challenge") ||
      path.includes("/password") ||
      path.includes("/tools/recaptcha") ||
      path.includes("/account/activate") ||
      path.includes("/recover")
    ) {
      return;
    }

    // ─── 登入狀態判斷 ────────────────────────────────────────────────
    const isLoggedIn = !!isShopifyCustomerLoggedIn;

    // ─── 語系判斷 ────────────────────────────────────────────────────
    const rawLang = (window.Shopify?.locale || document.documentElement.lang || "en").toLowerCase();
    const currentLang = rawLang.split("-")[0];

    // ─── 共用彈窗渲染函數 ────────────────────────────────────────────
    const renderPopup = (settings, storageKey, popupId) => {
      const activeContent = settings.content[currentLang] || settings.content.en;

      const popupWrapper = document.createElement("div");
      popupWrapper.id = "custom-popup";
      popupWrapper.style.cssText = `
        position:fixed; inset:0; width:100%; height:100%;
        background:rgba(0,0,0,0.65); z-index:9999;
        display:flex; align-items:center; justify-content:center;
        backdrop-filter: blur(3px);
      `;

      popupWrapper.innerHTML = `
        <div style="position:relative; width:90%; max-width:460px; animation: popupFadeIn 0.35s ease-out;">
          <a href="${activeContent.link}" target="_blank" rel="noopener noreferrer">
            <img src="${activeContent.img}" alt="Promotion"
                 style="width:100%; height:auto; display:block;"/>
          </a>
          <button id="popup-close" aria-label="Close"
            style="position:absolute; top:-18px; right:-18px; background:#111; color:#fff; border:3px solid #fff; border-radius:50%; width:38px; height:38px; font-size:24px; font-weight:bold; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:all 0.2s;">
            ×
          </button>
        </div>
        <style>
          @keyframes popupFadeIn { from { opacity:0; transform:scale(0.90) translateY(20px); } to { opacity:1; transform:scale(1) translateY(0); } }
          #popup-close:hover { transform:scale(1.12); background:#333; }
        </style>
      `;

      document.body.appendChild(popupWrapper);
      sessionStorage.setItem(storageKey, popupId);

      const closePopup = () => {
        popupWrapper.remove();
        document.body.style.overflow = "";
        document.removeEventListener("keydown", escHandler);
      };

      const escHandler = (e) => { if (e.key === "Escape") closePopup(); };

      document.addEventListener("keydown", escHandler);
      document.getElementById("popup-close").onclick = closePopup;
      popupWrapper.onclick = (e) => { if (e.target === popupWrapper) closePopup(); };

      document.body.style.overflow = "hidden";
    };

    // ─── 核心判斷 ─────────────────────────────────────────────────────
    const now = new Date();
    const marketingStart = new Date(marketingConfig.startTime);
    const marketingEnd   = new Date(marketingConfig.endTime);

    const shownMarketing = sessionStorage.getItem(marketingConfig.storageKey);
    const shownWelcome   = sessionStorage.getItem(welcomeConfig.storageKey);

    const isMarketingActive = now >= marketingStart && now < marketingEnd;
    const hasShownMarketingThisSession = shownMarketing === marketingConfig.id;
    const hasShownWelcomeThisSession   = shownWelcome   === welcomeConfig.id;

    // 行銷 Popup：活動期間內 + 這個 session 還沒顯示過 → 顯示（無論登入與否）
    if (isMarketingActive && !hasShownMarketingThisSession) {
      renderPopup(marketingConfig, marketingConfig.storageKey, marketingConfig.id);
      return;
    }

    // 迎新 Popup：這個 session 還沒顯示過 + **未登入** + 不是登入相關頁面
    if (!hasShownWelcomeThisSession && !isLoggedIn) {
      renderPopup(welcomeConfig, welcomeConfig.storageKey, welcomeConfig.id);
    }

  } catch (err) {
    console.error("[Polylulu Popup] Error:", err);
  }

  

});


